
export class SourceObjectAttributeFilterOptions {
    sourceObjectAttributeIds: Array<number>;
    sourceObjectIds: Array<number>;
}
